import React from 'react';
import { Row, Col, Tooltip, Button } from 'antd';
import { FaInfoCircle } from 'react-icons/fa';
import FareBreakdownCard from './FareBreakdownCard';

const ConvenienceChargeTotalFare = ({
    convenienceCharge,
    flightDetails,
    calculatedFee,
    applyDiscountShow,
    discountAmountOffer,
    finalTotal,
    handleConfirmAndPay,
    totalPriceBaggages,
    mealTotalAmount,
    totalAmount,
    totalAmountReturn,
    mealTotalAmountRetrun,
    totalSeatsPrice,
    totalSeatsPriceReturn
}) => {
    const fareRules = flightDetails?.flightDetails?.fareRules;
    if (!convenienceCharge) return null;

    return (
        <div className="traveller-card mt-4 px-3">
            <Row gutter={16} style={{ overflowY: 'auto', maxHeight: '420px', padding: '5px 0' }}>
                <Col xs={24}>

                    <FareBreakdownCard
                        flightDetails={flightDetails}
                        convenienceCharge={convenienceCharge}
                        calculatedFee={calculatedFee}
                        applyDiscountShow={applyDiscountShow}
                        discountAmountOffer={discountAmountOffer}
                        finalTotal={finalTotal}
                        mealTotalAmount={mealTotalAmount}
                        mealTotalAmountRetrun={mealTotalAmountRetrun}
                        totalAmount={totalAmount}
                        totalAmountReturn={totalAmountReturn}
                        totalSeatsPrice={totalSeatsPrice}
                        totalSeatsPriceReturn={totalSeatsPriceReturn}
                    />
                    <Col md={24} className='text-center'>
                        <Button
                            onClick={handleConfirmAndPay}
                            type='primary'
                            style={{ height: "42px" }}
                            className='btn btn-primary menu-block rounded mt-3'
                            aria-label="Pay now"
                        >
                            Pay Now
                        </Button>
                    </Col>



                </Col>
            </Row>
        </div >
    );
};

export default ConvenienceChargeTotalFare;
